export default __webpack_public_path__ + "_/shared_modules/PlatformError/images/open-box-0dd4bdba46c7dc482192552e2725f3ae.svg";